import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { PageLoader } from "./UI/Spinner";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <PageLoader message="Authenticating..." />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}